<script setup lang="ts">
import { watch, ref, computed, nextTick, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import WidgetFullScreenAd from './WidgetFullScreenAd.vue'

const FULLSCREEN_ZONE_ID = '37'
// Space reserved for zones with a fixed banner size, so the banner does not push the content
// down when it loads (CLS). Zone 27 serves 365x250 banners, scaled down in narrow sidebars.
const ZONE_SIZE_CLASSES: Record<string, string> = {
  '27': 'aspect-[365/250] max-h-[250px]'
}
const route = useRoute()
const config = useRuntimeConfig()
const props = defineProps<{ zoneid: string }>()
const isInitialized = ref(true)

const adAttrs = computed(() => ({
  [`data-${config.public.reviveProduct}-zoneid`]: props.zoneid,
  [`data-${config.public.reviveProduct}-id`]: config.public.reviveId
}))

const reviveRefresh = () => {
  if (config?.public?.reviveId && window.reviveAsync) {
    window.reviveAsync[config.public.reviveId].apply(
      window.reviveAsync[config.public.reviveId].detect()
    )
  }
}

watch(
  () => route?.path,
  () => {
    if (props.zoneid === FULLSCREEN_ZONE_ID) {
      isInitialized.value = false

      nextTick(() => {
        isInitialized.value = true
      })
    }
  },
  { immediate: false }
)

onMounted(() => reviveRefresh())
</script>

<template>
  <WidgetFullScreenAd
    v-if="props.zoneid === FULLSCREEN_ZONE_ID && config.public.reviveId && isInitialized"
    :zone-id="props.zoneid"
    :revive-id="config.public.reviveId"
  />
  <div
    v-else-if="config.public.reviveId && isInitialized"
    :class="['ReviveAd', ZONE_SIZE_CLASSES[props.zoneid]]"
  >
    <ins v-bind="adAttrs" />
  </div>
</template>
